<template>
  <div class="product-list">
    <div v-if="type !== 'uploadImage'">
      <div class="search">
        <el-input
          size="small"
          placeholder="搜索图片 名称/编号/标签"
          v-model="form.picName"
          class="input-with-select"
          clearable
          @change="getData"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="classify">
        <el-cascader
          ref="cascader"
          clearable
          v-model="typeId"
          :options="typeIdTree"
          :props="Object.assign(treeSelectProps, { expandTrigger: 'hover' })"
          style="width: 100%"
          size="small"
          :placeholder="typeName"
          @change="handleChangeType"
        >
        </el-cascader>
      </div>
      <div class="sort-box">
        <div
          :class="['sort-item', item.value === selectSort ? 'active' : '']"
          v-for="(item, index) in sorts"
          :key="index"
          @click="selectSortFn(item)"
        >
          {{ item.label }}
          <div class="sort-icons">
            <i
              :class="[
                'sort-icon',
                'up',
                'el-icon-caret-top',
                item.value === selectSort ? (selectSortUp ? 'active' : '') : '',
              ]"
            ></i>
            <i
              :class="[
                'sort-icon',
                'down',
                'el-icon-caret-bottom',
                item.value === selectSort ? (selectSortUp ? '' : 'active') : '',
              ]"
            ></i>
          </div>
        </div>
        <el-tooltip
          class="item toolbar-item"
          effect="dark"
          content="重置"
          placement="bottom"
        >
          <span @click="handleReset" class="iconfont iconsort-neat cp"></span>
        </el-tooltip>
      </div>
    </div>
    <div class="result">
      <div class="result-content">
        <div
          @click="handleClickProduct(record)"
          @mouseover="handlePreviewProduct(index)"
          @mouseout="handleCloseProduct(index)"
          v-for="(record, index) in productList"
          :key="index"
          class="item"
        >
          <img
            class="proImg"
            :src="
              `${record.picUrl}?x-oss-process=image/resize,m_fill,h_225,w_225/quality,q_100`
            "
          />
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="form.pageNum"
          layout="total, prev, next, jumper"
          :total="total"
          :page-size="30"
        >
        </el-pagination>
      </div>
    </div>
    <div
      @mouseenter="handleMouseoverPreview"
      @mouseleave="handleMouseoutPreview"
      v-if="showPreview"
      class="imgPanInfo"
    >
      <div class="imgPanInfoName">
        {{
          productList.length > 0 ? productList[previewProductIndex].picName : ""
        }}
      </div>
      <div style="margin: 0" class="imgPanInfoStandard">
        <span
          >编号：{{
            productList.length > 0 ? productList[previewProductIndex].mapId : ""
          }}</span
        >
      </div>
      <div class="imgPanInfoStandard">
        <span>分辨率：{{ detail.picWidth }} * {{ detail.picHeight }}px</span>
      </div>
      <div class="imgPanInfoDesigner"></div>
      <div class="imgPanInfoBig">
        <img
          width="100%"
          :src="
            productList.length > 0
              ? `${productList[previewProductIndex].picUrl}?x-oss-process=image/resize,m_fill,h_225,w_225/quality,q_100`
              : ''
          "
        />
      </div>
      <div
        style="overflow-y: auto; max-height: 100px"
        class="imgPanInfoStandard"
      >
        <div
          @click="handleJumpDesign(record)"
          v-for="(record, index) in designList"
          :key="index"
          style="cursor: pointer"
        >
          {{ index + 1 }} {{ record.proName }}
        </div>
      </div>
      <div class="imgPanInfoDesc scrollbar"></div>
    </div>
  </div>
</template>

<script>
import { getMapList } from "@/api/map/map"
import TreeSelect from "@/components/common/treeSelect"
import {
  listImgMap,
  listImgMapType,
  getImgMapTypeTree,
  addImgMap,
  editImgMap,
  getImgMapTypeSelect,
  deleteImgMap,
  listShare,
  listOrder,
  addShare,
  getShareTree,
  listMap,
  listDesign,
  listChild,
  listChildTree,
  updateName,
} from "@/api/customProduct/imageStore"
import { getMapInfo } from "@/api/map/map"

let timer = null

export default {
  name: "ImageList",
  components: {},
  props: {
    type: {
      type: String,
      default: "",
    },
    mapSource: {
      type: String,
      default: "01",
    },
    routeName: {
      type: String,
      default: "",
    },
    mapAttr: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectValue: "",
      optionsList: [
        {
          label: "归档图库",
          value: "1",
        },
        {
          label: "我的图库",
          value: "2",
        },
        {
          label: "示例图库",
          value: "3",
        },
      ],
      selectValue2: "",
      optionsList2: [
        {
          label: "aaaa",
          value: "1",
        },
        {
          label: "bbbb",
          value: "2",
        },
      ],
      selectSort: "1",
      selectSortUp: true,
      sorts: [
        {
          label: "创建时间",
          value: "createTime",
        },
        {
          label: "更新时间",
          value: "updateTime",
        },
        {
          label: "大小",
          value: "fileSize",
        },
      ],
      productList: [],
      currentPage: 1,
      keyword: "",
      classify: [],
      total: 0,
      form: {
        picName: "",
        mapSource: "",
        pageSize: 30,
        pageNum: 1,
        typeId: "",
        delFlag: "1",
      },
      previewProductIndex: 0,
      showPreview: false,
      isMouseIn: false,
      treeSelectProps: {
        value: "typeId", // ID字段名
        label: "typeName", // 显示名称
        children: "childrenTree", // 子级字段名
      }, // 图片分类
      typeIdMap: {},
      typeIdTree: [],
      typeId: [],
      typeName: "全部分类",
      detail: {},
      designList: [],
    }
  },
  watch: {
    routeName: {
      handler() {
        this.form.mapSource = this.mapSource
        if (this.routeName.indexOf("imageShare") > -1) {
          this.getImgShareTree()
        } else if (this.routeName.indexOf("imageOrder") > -1) {
        } else if (this.routeName.indexOf("imageMe") > -1) {
          this.getImgMapTypeTree("02")
        } else if (this.routeName.indexOf("imageSub") > -1) {
          this.getImgSubTree()
        } else if (
          this.routeName.indexOf("imageCommon") > -1 ||
          this.routeName.indexOf("mapmng") > -1
        ) {
          this.getImgMapTypeTree("01")
        }
      },
      immediate: true,
    },
  },
  methods: {
    selectSortFn(data) {
      this.selectSort = data.value
      this.selectSortUp = !this.selectSortUp
      this.form.orderByColumn = data.value
      this.form.isAsc = this.selectSortUp ? "asc" : "desc"
      this.getData()
    },
    handleJumpDesign(row) {
      let routeUrl = this.$router.resolve({
        path: "/select/custom/product",
        query: { designId: row.designId },
      })
      window.open(routeUrl.href, "_blank")
    },
    handleCurrentChange(pageNum) {
      this.form.pageNum = pageNum
      this.getData()
    },
    handleChangeClassify() {},
    getData() {
      this.startLoading()
      this.form.mapSource = this.mapSource
      let loadMethod = listImgMap
      this.form.mapAttr = this.mapAttr
      this.form.buyFlag = undefined
      if (this.routeName.indexOf("imageShare") > -1) {
        this.form.mapSource = "02"
        loadMethod = listShare
        this.menuTitle = "共享图库"
      } else if (this.routeName.indexOf("imageOrder") > -1) {
        this.form.mapSource = "02"
        this.form.mapAttr = "02"
        this.menuTitle = "刺绣图库"
      } else if (this.routeName.indexOf("imageMe") > -1) {
        this.form.mapSource = "02"
        this.form.mapAttr = "01"
        this.menuTitle = "印花图库"
      } else if (this.routeName.indexOf("imageSub") > -1) {
        loadMethod = listChild
        this.menuTitle = "子账号图库"
      } else if (
        this.routeName.indexOf("imageCommon") > -1 ||
        this.routeName.indexOf("mapmng") > -1
      ) {
        this.form.mapSource = "01"
        this.menuTitle = "收费图库"
        this.form.buyFlag = '01'
      }
      loadMethod(this.form)
        .then((res) => {
          this.productList = res.rows
          this.total = res.total
          if (this.typeIdTree.length > 0) {
            this.typeIdTree[0].typeName = this.typeIdTree[0].typeName.substring(
              0,
              this.typeIdTree[0].typeName.indexOf("(")
            )
            this.typeIdTree[0].typeName = `${this.typeIdTree[0].typeName}(${this.total})`
          }
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    cascaderClick(data) {
      this.typeId = [data.typeId]
      this.form.typeId = data.typeId
      this.typeName = data.typeName
      this.$refs.cascader.checkedValue = data.typeId
      this.$refs.cascader.computePresentText()
      this.$refs.cascader.toggleDropDownVisible(false)
      this.getData()
    },
    async handlePreviewProduct(index) {
      this.previewProductIndex = index
      this.showPreview = true
      this.isMouseIn = false
      timer ? window.clearTimeout(timer) : ""
      timer = window.setTimeout(() => {
        this.showPreview = false
      }, 1500)
      let result = await getMapInfo(
        this.productList[this.previewProductIndex].mapId
      )
      let response = await listDesign({
        mapId: this.productList[this.previewProductIndex].mapId,
        pageNum: 1,
        pageSize: 1000,
      })
      this.designList = response.rows
      this.detail = result.data
    },
    handleMouseoverPreview() {
      this.isMouseIn = true
      timer ? window.clearTimeout(timer) : ""
    },
    handleMouseoutPreview() {
      if (this.isMouseIn) {
        this.isMouseIn = false
        this.showPreview = false
      }
    },
    handleCloseProduct(index) {},
    handleClickProduct(record) {
      this.$emit("add", record)
    },
    /**查询分类树 */
    async getImgMapTypeTree(type) {
      this.form.mapAttr = "01"
      if (this.routeName.indexOf("imageOrder") > -1) {
        this.form.mapAttr = "02"
      }

      const { data } = await getImgMapTypeTree({
        type,
        mapAttr: this.form.mapAttr,
      })
      if (data) {
        data.map((record) => {
          record.typeName = `${record.typeName}(${record.imgNum})`
          if (record.childrenTree && record.childrenTree.length > 0) {
            record.childrenTree.map((item) => {
              item.typeName = `${item.typeName}(${item.imgNum})`
              if (item.childrenTree) {
                item.childrenTree.map((menu) => {
                  menu.typeName = `${menu.typeName}(${menu.imgNum})`
                })
              }
            })
          } else {
            record.childrenTree = false
          }
        })
      }
      this.typeIdTree = data
    },
    /**查询分类树 */
    async getImgShareTree() {
      const { data } = await getShareTree()
      if (data) {
        data.map((record) => {
          record.typeName = `${record.typeName}(${record.imgNum})`
          if (record.childrenTree) {
            record.childrenTree.map((item) => {
              item.typeName = `${item.typeName}(${item.imgNum})`
              if (item.childrenTree) {
                item.childrenTree.map((menu) => {
                  menu.typeName = `${menu.typeName}(${menu.imgNum})`
                })
              }
            })
          }
        })
        this.typeIdTree = data
      }
    },
    getTreeNodeId(value) {
      this.form.typeId = value
    },
    handleChangeType(value) {
      this.form.typeId = value[value.length - 1]
      this.getData()
    },
    handleReset() {
      this.form = {
        picName: "",
        mapSource: "",
        pageSize: 30,
        pageNum: 1,
        typeId: "",
        delFlag: "1",
      }
      this.selectSort = ""
      this.selectSortUp = true
      this.getData()
    },
  },
  mounted() {
    console.log(99)
    this.getData(true)
  },
}
</script>

<style lang="scss" scoped>
.product-list {
  position: relative;
}
.productPanInfo,
.imgPanInfo {
  position: fixed;
  width: 240px;
  left: 392px;
  top: 173px;
  background: #ffffff;
  box-shadow: 0 9px 28px 8px rgb(0 0 0 / 5%), 0 6px 16px 0 rgb(0 0 0 / 8%),
    0 3px 6px -4px rgb(0 0 0 / 12%);
  border-radius: 2px;
  padding: 10px 10px;
  color: rgb(77, 77, 77);
  overflow: hidden;
  z-index: 99;
  line-height: 24px;
  .imgPanInfoName {
  }
  .imgPanInfoStandard {
    font-size: 12px;
    color: #aaaaaa;
    margin: 0 0 5px 0;
  }
  .color-picker-list {
    overflow: hidden;
    margin-left: -4px;
  }
  .color-picker-list li,
  .color-picker-list-hover li,
  .mgg-preview-colors li {
    background-color: #fff;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: #d6d2d2 solid 1px;
    margin-left: 2px;
    padding: 1px;
    float: left;
  }

  .color-picker-list li.cur,
  .mgg-preview-colors li.cur {
    border: rgb(236, 78, 43) solid 2px;
  }

  .color-picker-list li a,
  .color-picker-list-hover li a,
  .mgg-preview-colors li a {
    width: 24px;
    height: 24px;
    display: table;
  }
}
.classify {
  display: flex;
  justify-content: space-between;
}

.sort-box {
  width: calc(100% - 8px);
  height: 32px;
  background: #0000000a;
  border-radius: 5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 16px;
  margin-right: 20px;

  .sort-item {
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;

    &.active {
      color: #4934b2 !important;
    }

    .sort-icons {
      line-height: 7px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .sort-icon {
        color: #ccc;
        line-height: 7px;

        &.active {
          color: #4934b2 !important;
        }
      }
    }
  }
}
.classify ::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #333333;
}
</style>
